import React from "react";
import LogoMiddle from "@/assets/logo/logomiddle.png";

const Header: React.FC = () => {
  return (
    <>
      <div className="containers-header w-full flex justify-between items-center px-2 md:px-10 ">
        {/* <div className="w-20 md:w-40">
          <img src={LogoLeft} alt="logo" />
        </div>
        <div className="w-52 md:w-auto md:mr-10">
          <img src={LogoRight} alt="logo" />
        </div> */}
      </div>
      <div className="w-auto px-3 mt-5">
        <img className="px-20" src={LogoMiddle} alt="logo" />
      </div>
    </>
  );
};

export default Header;
